// The capability is the whole of a merchant's answer: granted, they keep the
// assistant whatever they type, and without it no word reveals anything to them.
// revelio only ever opens the staff door, and staffPreview is a fact the server
// signs about the session rather than anything the browser can assert, so a
// merchant who learns the word still gets nothing. Absent or unresolved inputs
// read as false, which closes the door rather than opening it.
export function botWidgetsAvailable({ inContext, enabled, staffPreview, revealed } = {}) {
  if (!inContext) return false
  return Boolean(enabled) || (Boolean(staffPreview) && Boolean(revealed))
}

// Both widgets in one place so the two platforms cannot drift apart, and so the
// whole gate stays testable without mounting the app around it.
export function botWidgetVisibility(getters, revealed) {
  const source = getters || {}
  return {
    bottleBot: botWidgetsAvailable({
      inContext: source.isCateringContext,
      enabled: source.bottleBotEnabled,
      staffPreview: source.bottleBotStaffPreview,
      revealed
    }),
    ecommerceBot: botWidgetsAvailable({
      inContext: source.isEcommerceContext,
      enabled: source.ecommerceBotEnabled,
      staffPreview: source.ecommerceBotStaffPreview,
      revealed
    })
  }
}
